<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <br />
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Siding Image" left></v-img>
        </v-row>
        <v-row>
          <br />
          <p>
            {{ get("p-1.1") }}
          </p>
          <ul>
            <li>{{ get("p-1.2") }}</li>
            <li>{{ get("p-1.3") }}</li>
            <li>{{ get("p-1.4") }}</li>
            <li>{{ get("p-1.5") }}</li>
            <li>{{ get("p-1.6") }}</li>
          </ul>
        </v-row>
        <v-row class='break'>
          <p>
            {{ get("p-1.7") }}
          </p>
        </v-row>
        <v-row class='break'>
          <h2>{{ get("p-1.8") }}</h2>
          <p>
            {{ get("p-1.9") }}
             <phonenumber phone="(719) 390-7663"></phonenumber>!
          </p>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "trim-packages",

  components: {
    estimate,
    phonenumber,
  },

  created() {
    this.pageName = "trim";
  },

  data: () => ({
    image: require("@/assets/siding-6.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
.break {
  margin-top: 20px;
}
</style>
